import { getCurrentNumberFormatLocale, type NumberFormatLocale } from "./number-format";

export const DEFAULT_CURRENCY = "EUR";

export interface CurrencyFormatOptions {
  locale?: NumberFormatLocale | string;
  currency?: string;
  fractionDigits?: number;
}

export function createCurrencyFormatter({
  locale = getCurrentNumberFormatLocale(),
  currency = DEFAULT_CURRENCY,
  fractionDigits,
}: CurrencyFormatOptions = {}): Intl.NumberFormat {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    ...(fractionDigits !== undefined && {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }),
  });
}

export function formatCurrency(value: number, options: CurrencyFormatOptions = {}): string {
  return createCurrencyFormatter({ fractionDigits: 2, ...options }).format(value);
}
